import MentorApplicationApi from "../lib/MentorApplicationApi";
import MultiSelect from "vue-multiselect";
import {
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
  BSpinner,
  BFormInvalidFeedback
} from "bootstrap-vue";
import "vue-multiselect/dist/vue-multiselect.min.css";
import IdGeneratorFactory from "../lib/IdGeneratorFactory";
let idGenerator = IdGeneratorFactory("send_message_{count}");
import { IsNotEmptyArray, IsNotEmptyString } from "../lib/Validation";

export const ToUsersMixin = {
  data() {
    return {
      trackBy: "email"
    };
  },
  methods: {
    recipientLabel: option =>
      `${option.firstName} ${option.lastName} (${option.email})`,
    submit(e) {
      e.preventDefault();
      this.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.sending = true;
      let that = this;
      this.mentorApplicationApi
        .sendMessage(
          this.userId,
          this.formData.recipients.map(x => x.email),
          this.formData.subject,
          this.formData.body
        )
        .then(
          () => {
            that.sent = true;
            that.sending = false;
          },
          error => {
            that.sending = false;
            alert(
              `Unable to send the email: ${
                null === error?.response?.data?.error
                  ? "unknown error"
                  : error.response.data.error
              }`
            );
          }
        )
        .catch(() => {
          alert(`Unknown error sending the email`);
          that.sending = false;
        });
    }
  }
};

export const ToRolesMixin = {
  data() {
    return {
      trackBy: undefined
    };
  },
  methods: {
    recipientLabel: option => option,
    submit(e) {
      e.preventDefault();
      this.validate = true;
      if (this.hasValidationErrors) {
        return;
      }
      this.sending = true;
      let that = this;
      this.mentorApplicationApi
        .sendBulkMessage(
          this.formData.recipients,
          this.formData.subject,
          this.formData.body
        )
        .then(
          () => {
            that.sent = true;
            that.sending = false;
          },
          error => {
            that.sending = false;
            alert(
              `Unable to send the email: ${
                null === error?.response?.data?.error
                  ? "unknown error"
                  : error.response.data.error
              }`
            );
          }
        )
        .catch(() => {
          alert(`Unknown error sending the email`);
          that.sending = false;
        });
    }
  }
};

export const CommonMixin = {
  components: {
    MultiSelect,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    BSpinner,
    BFormInvalidFeedback
  },
  props: {
    userId: String,
    validRecipients: Array,
    initialSubject: String,
    initialMessage: String,
    initialRecipients: Array,
    apiRootUrl: String
  },
  computed: {
    recipients() {
      return IsNotEmptyArray(this.formData.recipients);
    },
    body() {
      return IsNotEmptyString(this.formData.body);
    },
    subject() {
      return IsNotEmptyString(this.formData.subject);
    },
    hasValidationErrors() {
      return [this.recipients, this.body, this.subject].some(
        x => true !== x.isValid
      );
    }
  },
  mounted() {
    // set the recipient if there is only one option
    if (1 === this.validRecipients.length) {
      this.formData.recipients = [this.validRecipients[0]];
    }
  },
  data: function() {
    return {
      recipientSelectId: idGenerator(),
      sent: false,
      sending: false,
      validate: false,
      mentorApplicationApi: new MentorApplicationApi(this.apiRootUrl),
      formData: {
        recipients: [],
        subject: null,
        body: null
      }
    };
  }
};
